import { render, staticRenderFns } from "./Unlawful2.vue?vue&type=template&id=54426f9d&scoped=true&"
import script from "./Unlawful2.vue?vue&type=script&lang=js&"
export * from "./Unlawful2.vue?vue&type=script&lang=js&"
import style0 from "./Unlawful2.vue?vue&type=style&index=0&id=54426f9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54426f9d",
  null
  
)

export default component.exports